import { Injectable, inject } from '@angular/core';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root'
})
export class MobileWarningService {
  private toastService = inject(ToastService);

  showMobileWarningIfNeeded(): void {
    if (this.isMobileDevice()) {
      this.toastService.showToast(
        'fi fi-sr-triangle-warning text-[24px] text-warning',
        'La experiencia en móvil no es la óptima en el Back Office y algunas funcionalidades podrían no estar disponibles. Recomendamos el uso de tablet o computadora.',
        'warning',
        'right',
        10000
      );
    }
  }

  private isMobileDevice(): boolean {
    const isMobileWidth = window.innerWidth <= 599;
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    const isMobileUA = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
    return isMobileWidth || isMobileUA;
  }
}
